export class Producto {
    id: number;
    nombre: string;
    //descricion: string;
    imagen: string;
    precio: number;
}